module.exports = __webpack_public_path__ + "Landingpage_Header_New.c15be98f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Landingpage_Header_New.png
// module id = 6iis
// module chunks = 0